<template>
  <v-container fluid>
    <section class='header'>
      <h5>PROJECTS</h5>
      <h2>Check out some of my creations.</h2>
    </section>

    <div class='portfolios mx-auto'>
      <div class='port-div mb-5'>
        <div>
          <v-hover v-slot='{ hover }' open-delay="200" close-delay="500">
            <v-card class='mx-auto port-card'
            >
              <v-img
              src='@/assets/covid.png'
              >
              </v-img>
              <v-overlay absolute opacity=.8 :value=hover z-index=1>
                <div class='port-info-wrapper'>
                  <div class='port-title'>Covid Tracker</div>
                  <div class='port-desc my-3'>A covid statistics tracker I made to improve my knowledge in utilizing APIs and mapping.<br>Technologies used: Vue.js, Leaflet, and Vuetify.</div>
                  <div class='port-actions'>
                    <v-btn class='mr-2' outlined href='https://dombrga.github.io/covid-tracker/' target='_blank'>Preview</v-btn>
                    <v-btn outlined href='https://github.com/dombrga/covid-tracker' target='_blank'>Github</v-btn>
                  </div>
                </div>
              </v-overlay>
            </v-card>
          </v-hover>
        </div>
        <div>
          <v-hover v-slot='{hover}' open-delay="200" close-delay="500">
            <v-card class='mx-auto port-card' 
            >
              <v-img
              src='@/assets/ping.png'
              >
              </v-img>
              <v-overlay absolute :value=hover opacity=.8 z-index=1>
                <div class='port-info-wrapper'>
                  <div class='port-title'>Ping Coming Soon</div>
                  <div class='port-desc my-3'>Responsive page to practice layouting and JavaScript.<br> Technologies used: HTML, CSS, and JavaScript.</div>
                  <div class='port-actions'>
                    <v-btn class='mr-2' outlined href='https://dombrga.github.io/ping-coming-soon/' target='_blank'>Preview</v-btn>
                    <v-btn outlined href='https://github.com/dombrga/ping-coming-soon' target='_blank'>Github</v-btn>
                  </div>
                </div>
              </v-overlay>
            </v-card>
          </v-hover>
        </div>
      </div>

      <div class='port-div mb-5'>
        <div>
          <v-hover v-slot='{hover}' open-delay="200" close-delay="500">
            <v-card class='mx-auto port-card' 
            >
              <v-img
              src='@/assets/nft.png'
              >
              </v-img>
              <v-overlay absolute :value=hover opacity=.8 z-index='1'>
                <div class='port-info-wrapper'>
                  <div class='port-title'>NFT Preview Card</div>
                  <div class='port-desc my-3'>An awesome and modern-looking card for practice.<br> Technologies used: HTML and CSS.</div>
                  <div class='port-actions'>
                    <v-btn class='mr-2' outlined href='https://dombrga.github.io/nft-preview-card' target='_blank'>Preview</v-btn>
                    <v-btn outlined href='https://github.com/dombrga/nft-preview-card' target='_blank'>Github</v-btn>
                  </div>
                </div>
              </v-overlay>
            </v-card>
          </v-hover>
        </div>

        <div>
          <v-hover v-slot='{hover}' open-delay="200" close-delay="500">
            <v-card class='mx-auto port-card' 
            >
              <v-img
              src='@/assets/stats.png'
              >
              </v-img>
              <v-overlay absolute opacity=.8 :value=hover z-index=1>
                <div class='port-info-wrapper'>
                  <div class='port-title'>NFT Preview Card</div>
                  <div class='port-desc my-3'>Simple card, but fun to create.<br> Technologies used: HTML and CSS.</div>
                  <div class='port-actions'>
                    <v-btn class='mr-2' outlined href='https://dombrga.github.io/stats-preview/' target='_blank'>Preview</v-btn>
                    <v-btn outlined href='https://github.com/dombrga/stats-preview' target='_blank'>Github</v-btn>
                  </div>
                </div>
              </v-overlay>
            </v-card>
          </v-hover>
        </div>
      </div>
    </div>

    <div class='frontendmentor text-center'>
      <v-btn outlined href='https://github.com/dombrga'
      target='_blank'
      class='px-7 py-5'
      >
        SEE MORE PROJECTS
      </v-btn>

      <p class='mt-5 to-come'>and more to come...</p>
    </div>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    picW: 300,
    picH: 200
  }),
  // watch: {
  //   '$vuetify.breakpoint.smAndUp': function(val) {
  //     console.log('smandup', this.$vuetify.breakpoint.smAndUp)
  //     if(val) {
  //       // this.picW = 400
  //       // this.picH = 230
  //       return
  //     }

  //     // this.picW = 300
  //     // this.picH = 200
  //   }
  // },
}
</script>

<style scoped>
/* typography */
.port-title,
.port-desc,
.port-actions >>> .v-btn,
.to-come {
  font-family: var(--poppins);
}

.port-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.port-desc {
  font-size: .65rem;
}

.port-actions >>> .v-btn {
  font-size: .6rem;
}


/* layout */

.container {
  padding: 90px 20px;
}

.header {
  margin-bottom: 50px;
}

.port-div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 20px;
  column-gap: 30px;
}

.port-card, .v-image {
  width: 300px;
  height: 200px;
}

.port-div >>> .v-overlay {
  /* z-index: 1; */
}
.v-overlay >>> .v-overlay__content {
  width: 100%;
}
.port-info-wrapper {
  padding: 0 20px;
}

.port-actions >>> .v-btn {
  border-color: var(--primary);
  width: 6.4rem;
}

.frontendmentor { margin-top: 3rem; }
.frontendmentor >>> .v-btn {
  border: 2px solid rgb(231, 77, 103);
}
.frontendmentor >>> .v-btn:hover {
  background-color: rgb(231, 184, 192);
}

@media (min-width: 600px) {
  .port-card, .v-image {
    width: 400px;
    height: 230px;
  }

  .port-title {
    font-size: 1.5rem;
    font-weight: 600;
  }

  .port-desc {
    font-size: .8rem;
  }

  .port-actions >>> .v-btn {
    font-size: .7rem;
  }
}

@media (min-width: 900px) {
  .port-div {
    flex-direction: row;
  }
}

</style>